<template>
  <transition name="pop">
    <div
      :id="id"
      class="toast"
      v-show="visible"
      :class="customClass"
    >
      <span class="text">{{ message }}</span>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
  .toast {
    position: fixed;
    width: 80%;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    box-sizing: border-box;
    text-align: center;
    z-index: 1000;
    padding: 10px;
    .text {
      font-size: 40px;
      display: block;
      padding: 27px 0;
      text-align: center;
    }
  }

  .placetop {
    top: 50px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .placemiddle {
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
  }

  .placebottom {
    bottom: 50px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .pop-enter, .pop-leave-active {
    opacity: 0;
  }
</style>

<script>
  export default {
    name: 'Toast',
    data() {
      return {
        visible: false,
        id: 'default',
        duration: 3000,
        message: '',
        position: 'center'
      }
    },
    computed: {
      customClass() {
        let classes = []
        switch (this.position) {
          case 'top':
            classes.push('placetop')
            break
          case 'bottom':
            classes.push('placebottom')
            break
          default:
            classes.push('placemiddle')
        }
        classes.push(this.className)
        return classes.join(' ')
      }
    },
    methods: {
      show() {
        this.visible = true
        if (this.duration) {
          this.timer = setTimeout(() => {
            this.hide()
          }, this.duration)
        }
      },
      hide(force) {
        this.visible = false
        if (force) {
          this.clearTimeout()
        }
      },
      clearTimeout() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
      }
    },
    watch: {
      visible(visible) {
        if (visible) {
          this.show()
        }
      }
    }
  }
</script>
